export { default } from './Button';
export type { IButton } from './Button';
